import { FormattedNumber } from 'i18n'
import { ListItem } from '../ListItem'
import { currencyFromSymbol } from 'shared/currency-utilities'

const EventRate = ({ rate, disabled, isActive = false, selectRate, selectedRateId }) => {
    const { eventName, rateName, rateId, currencySymbol, eventStartDate, amount } = rate

    React.useEffect(() => {
        if (calculateIsActive()) {
            selectRate(rate)
        }
    }, [])

    const calculateIsActive = () =>
        isActive ? isActive : selectedRateId ? String(rateId) === String(selectedRateId) : false

    const onClickHandler = () => {
        if (disabled) return

        selectRate(rate)
    }

    return (
        <ListItem
            onClick={onClickHandler}
            title={eventName}
            description={eventStartDate}
            shortDescription={rateName}
            price={<FormattedNumber value={amount} style="currency" currency={currencyFromSymbol(currencySymbol)} />}
            isActive={calculateIsActive()}
            disabled={disabled}
        />
    )
}

export default EventRate
